// PILOTAGE.UNIFIED.4 — règles PURES de navigation cockpit (aucun React, aucune commande de vol).
// Ne produit AUCUN GOTO/NAVPOINT/waypoint : uniquement de la navigation applicative + un verrou de sécurité.

const LAST_DRONE_KEY = "skycore_manual_control_last_drone";

export function getLastPilotDrone() {
  try { return localStorage.getItem(LAST_DRONE_KEY) || null; } catch { return null; }
}

export function setLastPilotDrone(droneId) {
  try { if (droneId) localStorage.setItem(LAST_DRONE_KEY, droneId); } catch { /* ignore */ }
}

export function droneNetworkState(d) {
  if (d?.status === "online") return "ONLINE";
  if (d?.status === "offline") return "OFFLINE";
  return "UNKNOWN";
}

// Résolution du drone : 1) dernier mémorisé encore présent  2) premier ONLINE  3) premier disponible  4) null.
// Jamais de hardcode d'ID.
export function resolvePilotDrone(drones, preferredId) {
  const list = Array.isArray(drones) ? drones : [];
  if (!list.length) return null;
  if (preferredId && list.some((d) => d.drone_id === preferredId)) return preferredId;
  const online = list.find((d) => d.status === "online");
  if (online) return online.drone_id;
  return list[0].drone_id;
}

const ACTIVE_ORCH_PHASES = [
  "GROUND_PREPARE", "ARMING", "ARMED", "TAKING_OFF", "WAITING_LOITER",
  "STABILIZING", "PRESTREAM", "OFFBOARD_ENTERING", "OFFBOARD_ACTIVE",
];
const ACTIVE_FE_PHASES = ["offboard_starting", "stabilizing", "active_hold", "active", "exiting"];
const ACTIVE_OFFBOARD_STATES = ["STABILIZING", "PRESTREAM", "REQUESTING_OFFBOARD", "ACTIVE", "HOLDING", "EXITING"];

// Raison PURE de verrouillage de la navigation cockpit (changer de drone démonterait la session de contrôle).
// Retourne null si navigation autorisée, sinon un code explicite. Fail-closed si lease active + état inconnu.
export function pilotNavigationLockReason({ sessionId, conn, safety, status, phase, orch, criticalAction } = {}) {
  if (criticalAction) return "critical_action";
  const s = safety || {};
  if (s.armed === true) return "drone_armed";
  if (s.landed_state != null && s.landed_state !== 1) return "drone_in_flight";
  if (orch?.phase && ACTIVE_ORCH_PHASES.includes(orch.phase)) return "orchestration_active";
  if (phase && ACTIVE_FE_PHASES.includes(phase)) return "phase_active";
  if (status?.state && ACTIVE_OFFBOARD_STATES.includes(status.state)) return "offboard_active";
  // Lease active mais état de vol inconnu => fail-closed. (Avant DÉMARRER, sans lease, l'absence
  // d'offboard_status n'empêche PAS de choisir un autre drone.)
  if (sessionId != null && (s.armed == null || s.landed_state == null)) return "flight_state_unknown";
  return null;
}

export const LOCK_REASON_LABEL = {
  critical_action: "DRONE VERROUILLÉ · ACTION CRITIQUE",
  drone_armed: "DRONE VERROUILLÉ · ARMÉ",
  drone_in_flight: "DRONE VERROUILLÉ · VOL EN COURS",
  orchestration_active: "DRONE VERROUILLÉ · SÉQUENCE DE VOL",
  phase_active: "DRONE VERROUILLÉ · OFFBOARD ACTIF",
  offboard_active: "DRONE VERROUILLÉ · OFFBOARD ACTIF",
  flight_state_unknown: "DRONE VERROUILLÉ · ÉTAT DE VOL INCONNU",
};
